// extracted by mini-css-extract-plugin
export default {"truncate":"style_truncate__J-LN4"};